import { FunctionComponent } from 'react';

import {
  StandardTextSpaced,
  StrongTextSpaced,
} from 'chime-ui/components/Typography';

const PayFAQText: FunctionComponent = () => (
  <>
    <StrongTextSpaced>
      What are instant transfers, and are they really free?
    </StrongTextSpaced>
    <StandardTextSpaced>
      Instant transfers allow you to transfer funds that were sent by a Chime
      member directly to any U.S. bank issued debit card - all for free.
    </StandardTextSpaced>
    <StandardTextSpaced>
      Once the Friend Transfer has been successfully claimed, the funds are
      transferred to the bank account associated with the debit card information
      you have provided.
    </StandardTextSpaced>
    <StandardTextSpaced>
      Funds availability may depend on your receiving bank. The funds transfer
      transaction may appear in processing or pending status and your available
      balance may not update until the transaction has been fully processed by
      your receiving bank. This may take up to 30 minutes depending on your
      bank.
    </StandardTextSpaced>
    <StandardTextSpaced>
      Instant transfers can be used to claim Friend Transfers 24 hours a day,
      365 days a year regardless of holiday or weekend schedules. Please note
      that claiming Friend Transfers may be affected by circumstances beyond our
      control (such as fire, flood, power failure, strike, labor dispute,
      critical service provider failure, computer breakdown, telephone line
      disruption, government or regulatory action, or a natural disaster),
      despite reasonable precautions that we have taken.
    </StandardTextSpaced>
    <StandardTextSpaced>
      Additionally, Friend Transfers are reviewed and could be declined,
      delayed, or blocked if the transfer could result in fraud or another form
      of financial harm. We may request you provide additional information to
      verify your identity.
    </StandardTextSpaced>
    <StandardTextSpaced>
      We may limit how many Friend Transfers you can claim and the amount of
      funds you can claim in a single day, week, or month.
    </StandardTextSpaced>
    <StandardTextSpaced>
      Funds that are sent to you by a Chime member are available to be claimed
      for 14 days from the time the Friend Transfer is initiated. After 14 days,
      the transaction will expire, and the funds will automatically be
      transferred back to the sending Chime Member.
    </StandardTextSpaced>
    <StrongTextSpaced>
      How do I know if I have an eligible bank account or debit card?
    </StrongTextSpaced>
    <StandardTextSpaced>
      Instant transfers only work with U.S. bank issued debit cards. Credit
      cards, pre-paid cards, and debit cards issued by foreign banks will not be
      eligible to use with this feature.
    </StandardTextSpaced>
    <StrongTextSpaced>
      Why did I get an error when I tried to instantly transfer funds to my bank
      account?
    </StrongTextSpaced>
    <StandardTextSpaced>
      Instant transfers can be reviewed and declined for a variety of reasons,
      including Chime’s automated internal security measures. Before attempting
      an instant transfer, please make sure you’re using a card that is
      registered in your own name. Likewise, here is are some common reasons why
      you might be receiving an error message:
    </StandardTextSpaced>
    <StandardTextSpaced as="span">
      <ol>
        <li>Did I enter my debit card information correctly?</li>
        <li>Did my debit card expire?</li>
        <li>
          Does the ZIP code I entered match the ZIP code on file with my debit
          card?
        </li>
        <li>Did I enter my credit card information?</li>
        <li>Did I enter my pre-paid information? </li>
        <li>
          Did I enter my foreign bank account issued debit card information?
        </li>
        <li>Has it been more than 14 days since the payment was sent?</li>
        <li>Have I already claimed these funds?</li>
        <li>
          Would claiming these funds place me over the non-member recipient
          dollar limit?
        </li>
      </ol>
    </StandardTextSpaced>
    <StandardTextSpaced>
      If you continue to receive an error message after considering the above,
      this means that the instant transfer feature you can use to claim your
      Friend Transfer is not currently available. This might happen even if
      you’ve used a debit card for instant transfer successfully in the past.
    </StandardTextSpaced>
    <StrongTextSpaced>
      How do I check on the status of my instant transfer?
    </StrongTextSpaced>
    <StandardTextSpaced>
      After you have successfully provided a valid name, email address, and U.S.
      debit card information for the transfer, you will receive a confirmation
      on the web page indicating whether the transfer was successful. You will
      also receive an email confirmation of the successful transfer as well.
    </StandardTextSpaced>
    <StandardTextSpaced>
      You can also check the status of the transaction from your bank account.
      You can reach out to your bank directly if your transfer is not showing on
      your bank statement. When you contact them, it’s important to explain that
      the money will appear as an original credit transaction (OCT) or a
      real-time payment, not a missing ACH/direct deposit.
    </StandardTextSpaced>
  </>
);

export default PayFAQText;
